module.exports = __webpack_public_path__ + "img/clickfunnels_6.8590327b.png";